/* ============================================
   MOBILE MENU FRESH — vanilla JS
   Geen custom elements, geen dependencies.
   Open/close drawer + accordion toggle.
   ============================================ */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-mm-drawer]');
    if (!drawer) return;

    var openBtns = document.querySelectorAll('[data-mm-open]');
    var closeBtns = drawer.querySelectorAll('[data-mm-close]');
    var accordionBtns = drawer.querySelectorAll('[data-mm-accordion]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mm-locked');
      openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-locked');
      openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    });

    // Click-outside-panel: sluit als gebruiker naast het panel klikt
    drawer.addEventListener('click', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      var panel = drawer.querySelector('.mm-drawer__panel');
      if (panel && !panel.contains(e.target)) {
        closeDrawer();
      }
    });

    // Escape key sluit het menu
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Accordion toggle
    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = btn.nextElementSibling;
        if (!panel) return;

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
        } else {
          // Optioneel: sluit andere panels (accordion-stijl). Uit voor multi-open.
          // accordionBtns.forEach(function (other) {
          //   if (other !== btn) {
          //     other.setAttribute('aria-expanded', 'false');
          //     var op = other.nextElementSibling;
          //     if (op) op.classList.remove('is-open');
          //   }
          // });
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });

    // ESC sluit drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
